import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { User } from '../../calvin-emr-shared/models/user.model';
import { PatientListDialogComponent } from 'src/app/patients/patient-list-page/patient-list-dialog/patient-list-dialog.component';
import { StudentDialogComponent } from 'src/app/students/student-dialog/student-dialog.component';
import { Table, TableModule } from 'primeng/table';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { PATH_ASSIGN_PATIENTS, PATH_STUDENTS } from '../students.global';
import { StudentsPageComponent } from '../students-page/students-page';
import { ButtonDirective, ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { PrimeTemplate } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { FileUploadDialogComponent } from '../../shared/file-upload-dialog/file-upload-dialog.component';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { DialogModule } from 'primeng/dialog';
import { COLLECTION_USERS, ROLE_STUDENT } from 'src/app/calvin-emr-shared/global';
import { EmrInputComponent } from '../../shared/emr-input/emr-input.component';
import { MessageService } from 'primeng/api';

/**
 * Page responsible for handling all the student/user/nurse related activities
 * including assgining or deleting patient(s) from the user or uploading more students
 */
@Component({
  selector: 'app-student-list-page',
  templateUrl: './student-list-page.component.html',
  styleUrls: ['./student-list-page.component.scss'],
  providers: [DialogService],
  standalone: true,
  imports: [
    ButtonDirective,
    CheckboxModule,
    FormsModule,
    TableModule,
    PrimeTemplate,
    InputTextModule,
    TooltipModule,
    FileUploadDialogComponent,
    ConfirmationDialogComponent,
    IconField,
    InputIcon,
    DialogModule,
    ButtonModule,
    ReactiveFormsModule,
    EmrInputComponent,
  ],
})
export class StudentListPageComponent extends StudentsPageComponent implements OnInit, OnDestroy {
  router = inject(Router);

  private readonly onDestroy = new Subject<void>();

  assignPatientsPath = `/${PATH_STUDENTS}/${PATH_ASSIGN_PATIENTS}`;

  students: User[] = [];

  /**
   * The list of students to display in the table.
   */
  selectedStudents: User[] = [];

  showDeleteStudentDialog = false;
  confirmDeleteStudents = false;

  /**
   * The PrimeNG table HTML element.
   */
  @ViewChild('studentTable') studentTable: Table | undefined;

  /**
   * The fields to filter the table by when using the search bar.
   */
  tableFilterFields: string[] = ['firstName', 'lastName', 'email'];

  // Used for importing users
  file?: Blob;
  importedStudents: string[] = [];
  importErrors: string[] = [];
  showImportStudentsDialog = false;
  showImportStudentsResultsDialog = false;

  // Add single-student UI state
  showAddStudentDialog = false;
  newStudent: User = new User();
  isAddingStudent = false;

  // Form controls for add-student dialog
  newStudentEmailControl = new UntypedFormControl('', [Validators.required, Validators.email]);
  newStudentFirstNameControl = new UntypedFormControl('', Validators.required);
  newStudentLastNameControl = new UntypedFormControl('', Validators.required);
  // newStudentRoleControl = new UntypedFormControl('');

  // default the role to 'student' and disable editing
  newStudentRoleControl = new UntypedFormControl({ value: ROLE_STUDENT, disabled: true });

  private dialogService = inject(DialogService);
  public messageService = inject(MessageService);

  constructor() {
    super();
    this.fetchStudents();
    // TODO: open student dialog if the admin is navigating back from Patient Dashboard
    // store
    //   .select(selectStudent)
    //   .pipe(takeUntil(this.onDestroy))
    //   .subscribe((student: User | null) => {
    //     if (student) {
    //       const dialogRef = this.dialogService.open(StudentDialogComponent, {
    //         header: `Viewing Student: ${student.firstNameLastName}`,
    //         data: student,
    //         width: '70%',
    //       });
    //     }
    //   });
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  /**
   * Filters the data in the table based on the text in the search field
   * HTML input element. The data is filtered based on whether the any
   * of the fields in the tableFilterFields array contain the text.
   *
   * @param target The search field HTML input element.
   */
  filterTable(target: EventTarget | null) {
    if (target) {
      this.studentTable?.filterGlobal((target as HTMLInputElement).value, 'contains');
    }
  }

  openStudentDialog(student: User) {
    const dialogRef = this.dialogService.open(StudentDialogComponent, {
      header: `Viewing Student: ${student.firstNameLastName}`,
      data: student,
      width: '70%',
      closable: true,
    });
  }

  /**
   * Flip "checked" boolean value of the student after clicking the checkbox
   *
   * @param event
   */
  studentCheckToggle(event: any) {
    // Get the index value of checked student row
    // let index = this.students.findIndex(obj => obj.student.getId() == event);
    // flip checked boolean value of a index row
    // this.students[index].checked = this.students[index].checked? false : true;
  }

  /**
   * Add student object to the "students" array
   *
   * @param res User firebase document containing user information
   */
  // vtn2: this is not used currently.
  // addStudent(res: any) {
  //   const student = new User();
  //   Object.assign(student, res.data());

  //   this.students.push(
  //     new User(res.id, student.email, student.firstName, student.lastName, student.role)
  //   );
  // }

  // Open modal dialog
  openDialog(operation: string): void {
    const dialogRef = this.dialogService.open(PatientListDialogComponent, {
      width: '50%',
      data: {
        title: 'List of Patients',
        prompt: `Which patients would you like to ${operation}?`,
        buttonLabel: `${operation} Patients`,
        patients: this.patients,
        type: 'studentPatient',
      },
    });
  }

  openDeleteStudentsDialog() {
    this.showDeleteStudentDialog = true;
  }
  onCloseDeleteStudentsDialog(didConfirm: boolean) {
    if (didConfirm) {
      this.deleteStudents();
    } else {
      this.confirmDeleteStudents = false;
    }
  }
  deleteStudents() {
    this.selectedStudents.forEach(async (student) => {
      this.userService.deleteStudentIDFromAllUsers(student.id);

      await this.userService.deleteUser(student.id, COLLECTION_USERS);
      this.students = this.students.filter((s) => s.id !== student.id);
    });
    this.selectedStudents = [];
  }

  /**
   * Function used for filter function. Returns true for users checked
   * at the student list table and false for otherwise.
   *
   * @param user
   * @returns boolean
   */
  studentChecked(user: any) {
    return user.checked;
  }

  /**
   * Update studentPatient document in the firebase
   * Currently work in progress (Need a way to only update the difference between
   * the template patient data and studentPatient data)
   *
   * @param patientUid  identification number for the selected patient template
   * @param data        patient data for the selected patient template
   * @param studentList list of selected students
   * @param col         collection value for the firebase
   */
  // updatePatient(patientUid: string, data: Patient, studentList: string[], col: string) {
  //   let tempObj: Object = {};

  //   // Check if any student is selected
  //   if (studentList.length) {
  //     studentList.forEach((studId) => {
  //       // Checks if student has a assigned studentPatient document
  //       this.patientService.patientDuplicateCheck(studId, patientUid, col).then((res) => {
  //         // Student has a studentPatient document
  //         if (!res.empty) {
  //           res.docs.forEach((doc) => {
  //             tempObj = merge(doc.data(), this.objectDifference(data, doc.data()));
  //             console.log(tempObj);
  //             // Update studentPatient document
  //             // this.patientService.setPatient(doc.id, tempObj, "studentPatients")
  //           });
  //         } else {
  //           alert('patient not available');
  //         }
  //       });
  //     });
  //   } else {
  //     alert('no student was selected');
  //   }

  //   console.log('updatePatient work!');
  // }

  /**
   * Open dialog box for the importing students.
   */
  openImportStudentsDialog() {
    this.showImportStudentsDialog = true;
    this.importErrors = [];
  }

  openAddStudentDialog(): void {
    this.newStudent = new User();
    this.isAddingStudent = false;
    this.newStudentEmailControl.reset('');
    this.newStudentFirstNameControl.reset('');
    this.newStudentLastNameControl.reset('');
    this.newStudentRoleControl.reset({ value: ROLE_STUDENT, disabled: true });
    this.showAddStudentDialog = true;
  }

  onCloseImportStudentsDialog(file?: Blob) {
    if (file) {
      const fileReader = new FileReader();
      fileReader.onload = (progressEvent) => {
        const fileResult = progressEvent.target?.result as string;
        const studentArray = this.getStudentsFromFile(fileResult);
        if (studentArray.length > 0) {
          this.importStudents(studentArray);
        }
      };
      fileReader.readAsText(file);
    }
  }

  async addSingleStudent(): Promise<void> {
    this.newStudentEmailControl.markAsTouched();
    this.newStudentFirstNameControl.markAsTouched();
    this.newStudentLastNameControl.markAsTouched();

    // check if student email field has value
    const emailValue = (this.newStudentEmailControl.value || '').toString();
    const emailHasValue = emailValue.length > 0;

    if (
      this.newStudentEmailControl.invalid ||
      this.newStudentFirstNameControl.invalid ||
      this.newStudentLastNameControl.invalid
    ) {
      this.messageService.clear();

      // show invalid email error if field has invalid value
      if (emailHasValue && this.newStudentEmailControl.invalid) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Email',
          detail: 'Student email must be a valid Calvin email domain.',
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Please fill out all required fields with valid information.',
        });
      }
      return;
    }

    this.newStudent.email = this.newStudentEmailControl.value;
    this.newStudent.firstName = this.newStudentFirstNameControl.value;
    this.newStudent.lastName = this.newStudentLastNameControl.value;
    this.newStudent.role =
      (this.newStudentRoleControl.value || ROLE_STUDENT).toString().trim().toLowerCase() ||
      ROLE_STUDENT;
    this.newStudent.sanitize();

    if (!this.isValidUser(this.newStudent)) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Email',
        detail: 'Student email must be a valid Calvin email domain.',
      });
      return;
    }

    try {
      this.isAddingStudent = true;
      const studentWithNewUid = await this.userService.createUserAccount(this.newStudent);

      await this.userService.upsertUserDocument(studentWithNewUid);
      this.fetchStudents();

      this.messageService.clear();
      this.messageService.add({
        severity: 'success',
        summary: 'Student Added',
        detail: `${this.newStudent.firstName} ${this.newStudent.lastName}`,
      });

      this.showAddStudentDialog = false;
    } catch (err: any) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err.message || 'Unable to add student.',
      });
    } finally {
      this.isAddingStudent = false;
    }
  }

  /**
   * Compare two objects and return the differences and common values
   * Potentially used for the updating studentPatient object in firebase
   * Code URL: https://newbedev.com/javascript-typescript-get-difference-between-two-objects-code-example
   *
   * @param origObj   Object 1 for comparison
   * @param newObj    Object 2 for comparison
   * @returns object type that contains difference or commonality of two objects
   */

  // objectDifference(origObj: Object, newObj: Object) {
  //   const changes = (newObj: Object, origObj: Object) => {
  //     let arrayIndexCounter = 0;
  //     return transform(newObj, function (result: any, value, key) {
  //       if (!isEqual(value, origObj[key])) {
  //         const resultKey = isArray(origObj) ? arrayIndexCounter++ : key;
  //         result[resultKey] =
  //           isObject(value) && isObject(origObj[key]) ? changes(value, origObj[key]) : value;
  //       }
  //     });
  //   };
  //   return changes(newObj, origObj);
  // }

  // objectSame(origObj: Object, newObj: Object) {
  //   const changes = (newObj: Object, origObj: Object) => {
  //     let arrayIndexCounter = 0;
  //     return transform(newObj, function (result: any, value, key) {
  //       if (isEqual(value, origObj[key])) {
  //         const resultKey = isArray(origObj) ? arrayIndexCounter++ : key;
  //         result[resultKey] =
  //           isObject(value) && isObject(origObj[key]) ? changes(value, origObj[key]) : value;
  //       }
  //     });
  //   };
  //   return changes(newObj, origObj);
  // }

  /**
   *
   * @param result The string created by the FileReader.
   */
  getStudentsFromFile(result: string) {
    const studentArray: User[] = [];

    // Clear any previous import errors
    this.importErrors = [];

    const rows = result.split(/\r?\n/).filter((row) => row.trim().length > 0);

    if (rows.length === 0) {
      return studentArray;
    }

    const headerCells = this.parseCsvRow(rows.shift() || '').map((header) =>
      this.normalizeHeader(header)
    );

    const emailIndex = this.findColumnIndex(headerCells, ['email', 'emailaddress']);
    const firstNameIndex = this.findColumnIndex(headerCells, ['firstname']);
    const lastNameIndex = this.findColumnIndex(headerCells, ['lastname']);
    const roleIndex = this.findColumnIndex(headerCells, ['role']);

    // Drop falsy placeholders so the array only contains headers that were actually missing
    const missingRequiredHeaders = [
      emailIndex === -1 ? 'email' : null,
      firstNameIndex === -1 ? 'firstName' : null,
      lastNameIndex === -1 ? 'lastName' : null,
    ].filter(Boolean) as string[];

    if (missingRequiredHeaders.length > 0) {
      this.importErrors.push(
        `Missing required column header(s): ${missingRequiredHeaders.join(', ')}.`
      );
    }

    rows.forEach((studentInfoString) => {
      if (missingRequiredHeaders.length > 0) {
        return;
      }

      try {
        const params = this.parseCsvRow(studentInfoString);

        const email = params[emailIndex] ? params[emailIndex].trim() : '';
        const firstName = params[firstNameIndex] ? params[firstNameIndex].trim() : '';
        const lastName = params[lastNameIndex] ? params[lastNameIndex].trim() : '';
        const role =
          roleIndex !== -1 && params[roleIndex] ? params[roleIndex].trim() : ROLE_STUDENT;

        const student = new User(email, firstName, lastName, role);

        if (!this.isValidUser(student)) {
          throw new Error();
        }

        studentArray.push(student);
      } catch (e) {
        this.importErrors.push(studentInfoString);
      }
    });

    // Display errors, if any
    if (this.importErrors.length > 0) {
      const errorString = this.importErrors.join('\n');
      console.error(
        'Could not import the following data:',
        errorString,
        '\nVerify that your file is correctly formatted and that no data is missing.'
      );
      this.showImportStudentsResultsDialog = true;
    }

    return studentArray;
  }

  // Helper to parse CSV fields with quotes; generated by AI assistance
  private parseCsvRow(row: string): string[] {
    const values: string[] = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < row.length; i++) {
      const char = row[i];

      if (char === '"') {
        if (inQuotes && row[i + 1] === '"') {
          current += '"';
          i++;
          continue;
        }
        inQuotes = !inQuotes;
        continue;
      }

      if (char === ',' && !inQuotes) {
        values.push(current);
        current = '';
        continue;
      }

      current += char;
    }

    values.push(current);

    return values.map((value) => value.trim());
  }

  private normalizeHeader(header: string): string {
    return header.toLowerCase().replace(/[\s_-]+/g, '');
  }

  private findColumnIndex(headers: string[], acceptableNames: string[]): number {
    return headers.findIndex((h) => acceptableNames.includes(h));
  }

  importStudents(studentArray: User[]) {
    studentArray.forEach(async (student: User, idx: number) => {
      student.sanitize();
      const studentWithNewUid = await this.userService.createUserAccount(student);
      await this.userService.upsertUserDocument(studentWithNewUid);

      // after the last update, reload the table. (Put it outside the loop and it runs too early.)
      if (idx === studentArray.length - 1) {
        this.fetchStudents();
      }
    });
  }

  routeToAssignPatientsPage() {
    this.router.navigate([this.assignPatientsPath], {
      queryParams: { data: JSON.stringify(this.selectedStudents) },
    });
  }

  isValidUser(student: User) {
    return student.hasValidEmail;
  }

  get didSelectStudents() {
    return this.selectedStudents.length > 0;
  }
}
